import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import { createPinia } from "pinia";
import "./styles/tailwind.css";
import "./styles/main.scss";
import { axiosSymbol, routerSymbol } from "./symbols";
import { useUserStore } from "./stores/user";

(async function () {
    const pinia = createPinia();
    const userStore = useUserStore(pinia);

    await userStore.fetchUser();

    const app = createApp(App)
        .use(router)
        .use(pinia)
        .provide(axiosSymbol, axios)
        .provide(routerSymbol, router);

    app.mount("#app");
})();